<script>
import Cookies from 'js-cookie';
import JetNavLink from '@/Jetstream/NavLink.vue';

export default {
  name: 'ProfileAlertMixin',
  components: { JetNavLink },

  data() {
    return {
      userData: this.$page.props.user,
      sessionLifetime: this.$page.props.sessionLifetime / (24 * 60),
      alertIsVisible: false,
    };
  },

  mounted() {
    if (this.currentPageCanContainAlerts()) {
      const profileSectionFilled = this.checkIfProfileSectionFilled();

      if (profileSectionFilled) {
        this.alertIsVisible = false;
      } else {
        this.checkIfAletrWasClosed();
      }
    }
  },

  methods: {
    getLinkToDashboardPage() {
      switch (this.userData.role) {
        case 'clinician':
        case 'admin':
          return route('dashboard.clinician');
        default:
          return route('dashboard');
      }
    },

    getLinkToProfilepage() {
      switch (this.userData.role) {
        case 'clinician':
        case 'admin':
          return route('clinician.profile.show');
        default:
          return route('profile.show');
      }
    },

    currentPageCanContainAlerts() {
      const availablePages = [this.getLinkToDashboardPage(), this.getLinkToProfilepage()];
      const currentPageUrl = window.location.href;

      return availablePages.includes(currentPageUrl);
    },

    closeAlert() {
      this.alertIsVisible = false;

      this.createOrupdateCookie();
    },

    checkIfProfileSectionFilled() {
      return !!this.userData[this.profileSectionName];
    },

    checkIfAletrWasClosed() {
      if (Cookies.get(this.alertSeenCookieName)) {
        this.alertIsVisible = false;

        // if cookie already has been set, we shold "update" lifetime
        this.createOrupdateCookie();
      } else {
        this.alertIsVisible = true;
      }
    },

    createOrupdateCookie() {
      Cookies.set(this.alertSeenCookieName, 'true', { expires: this.sessionLifetime });
    },
  },
};
</script>
